import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { Observable } from "rxjs";
import { HttpclientService } from "../../../shared";
import { ScheduledJobRequestInfo } from "../application-process/shared/ScheduledJobRequestInfo";
import { ChangeSchoolRequestModel } from "../district-school-maintenance/shared/ChangeSchoolRequestModel";
import { ZeroFinesMealRequestModel } from "../district-zero-accounts/ZeroFinesMealRequestModel";
import { ZeroMeritsRequestModel } from "../district-zero-accounts/ZeroMeritsRequestModel";
import { ZeroPBISRequestModel } from "../district-zero-accounts/ZeroPBISRequestModel";
import { DistCalData } from "../districtcalendar/DistCalData";
import { DistrictUpdateRequest } from "../districtcontactinfo/DistrictUpdateRequest";
import { DistrictDefaultPageRequest } from "../districtsettings/shared/DistrictDefaultPageRequest";
import { UpdateDistEmailRequest } from "../districtsettings/shared/UpdateDistEmailRequest";
import { DistrictUpdateNightlyAttendanceRequest } from "../districtsettings/shared/UpdateNightlyAttendanceRequest";
import { UpdatePhotoIDRequest } from "../districtsettings/shared/UpdatePhotoIDRequest";
import { UpdateDistSecurityRequest } from "../security-settings/UpdateDistSecurityRequest";
import { AddSchoolRequest } from "../district-school-maintenance/shared/AddSchoolRequest";
import { StringRequest } from "../districtsettings/shared/StringRequest";
import { CalendarHolidayInsertRequest } from "../districtcalendar/district-calendar-holiday-view/shared/calendar-holiday-insert-request";
import { CalendarHolidayImportRequest } from "../districtcalendar/district-calendar-holiday-view/shared/calendar-holiday-import-request";
import { PortalAppSettingsRequest } from "./portal-app-settings-request";

@Injectable()
export class DistrictAdministrationService {
	constructor(private httpclientService: HttpclientService) {}

	DistrictList() {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/DistrictList";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
	DistrictUpdate(parms: DistrictUpdateRequest) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/DistrictUpdate";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
	EmailGet(EMailSMSProviderID) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/EmailGet?EMailSMSProviderID=" + EMailSMSProviderID;

		var promise$ = this.httpclientService.post(url, null);

		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
	SMSEmailUpdate(EMailSMSProviderID, EMailSMSProviderName, EmailSMSProviderEmailInfo) {
		var postResult$ = new Subject();
		var url =
			"DistrictAdministration/EmailProviderUpdate?EMailSMSProviderID=" +
			EMailSMSProviderID +
			"&EMailSMSProviderName=" +
			EMailSMSProviderName +
			"&EmailSMSProviderEmailInfo=" +
			EmailSMSProviderEmailInfo; // + '&DefinedByID=' + DefinedByID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
	SMSEmailInsert(EMailSMSProviderName, EmailSMSProviderEmailInfo) {
		var postResult$ = new Subject();
		var url =
			"DistrictAdministration/EmailProviderInsert?EMailSMSProviderName=" +
			EMailSMSProviderName +
			"&EmailSMSProviderEmailInfo=" +
			EmailSMSProviderEmailInfo; // + '&DefinedByID=' + DefinedByID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
	EmailDelete(EMailSMSProviderID) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/EmailDelete?EmailSMSProviderID=" + EMailSMSProviderID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	FacilityGet(FacilityID) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/FacilityGet?FacilityID=" + FacilityID;

		var promise$ = this.httpclientService.post(url, null);

		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	SchoolTypeGet(SchoolTypeID) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/SchoolTypeGet?SchoolTypeID=" + SchoolTypeID;

		var promise$ = this.httpclientService.post(url, null);

		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
	SchoolTypeUpdate(SchoolTypeID, SchoolTypeCD, SchoolTypeDesc) {
		var postResult$ = new Subject();
		var url =
			"DistrictAdministration/SchoolTypeUpdate?SchoolTypeID=" + SchoolTypeID + "&SchoolTypeCD=" + SchoolTypeCD + "&SchoolTypeDesc=" + SchoolTypeDesc; // + '&DefinedByID=' + DefinedByID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
	SchoolTypeInsert(SchoolTypeID, SchoolTypeCD, SchoolTypeDesc) {
		var postResult$ = new Subject();
		var url =
			"DistrictAdministration/SchoolTypeInsert?SchoolTypeID=" + SchoolTypeID + "&SchoolTypeCD=" + SchoolTypeCD + "&SchoolTypeDesc=" + SchoolTypeDesc; // + '&DefinedByID=' + DefinedByID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
	SchoolTypeDelete(SchoolTypeID) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/SchoolTypeDelete?SchoolTypeID=" + SchoolTypeID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
	GradeLevelGet(GradeLevelID) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/GradeLevelGet?GradeLevelID=" + GradeLevelID;

		var promise$ = this.httpclientService.post(url, null);

		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
	GradeLevelUpdate(GradeLevelID, GradeLevelDesc, MealAccountCreditLimit) {
		var postResult$ = new Subject();
		var url =
			"DistrictAdministration/GradeLevelUpdate?GradeLevelID=" +
			GradeLevelID +
			"&GradeLevelDesc=" +
			GradeLevelDesc +
			"&MealAccountCreditLimit=" +
			MealAccountCreditLimit; // + '&DefinedByID=' + DefinedByID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
	GradeLevelMoveUp(currentgradelevelid, PreviousGradeLevelID) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/GradeLevelMoveUp?CurrentGradeLevelID=" + currentgradelevelid + "&PreviousGradeLevelID=" + PreviousGradeLevelID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
	GradeLevelMoveDown(currentgradelevelid, NextGradeLevelID) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/GradeLevelMoveDown?currentgradelevelid=" + currentgradelevelid + "&NextGradeLevelID=" + NextGradeLevelID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
	SchoolGet(SchoolID) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/SchoolGet?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);

		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	LoadDistrictPreferences(applicationID) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/LoadDistrictPreferenceList?ApplicationID=" + applicationID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	LoadDefaultImages(applicationID) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/LoadDefaultPhotoList?ApplicationID=" + applicationID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	UpdateReportSettings(applicationID, NumDays) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/UpdateReportSettings?ApplicationID=" + applicationID + "&NumDays=" + NumDays;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	UpdateInfractionSettings(applicationID, MustAddAction) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/UpdateInfractionSettings?ApplicationID=" + applicationID + "&MustAddAction=" + MustAddAction;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	UpdateScanStationMustLogInSetting(applicationID, MustLogInAction) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/UpdateScanStationMustLogInSetting?ApplicationID=" + applicationID + "&MustLogInAction=" + MustLogInAction;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	UpdatePhotoIDSettings(parms: UpdatePhotoIDRequest) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/UpdatePhotoIDSettings";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	UpdateSchoolDomainSettings(applicationID, AllowDomain) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/UpdateSchoolDomainSettings?ApplicationID=" + applicationID + "&AllowDomain=" + AllowDomain;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	LoadDistrictEmail(applicationID) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/LoadDistrictEmail?ApplicationID=" + applicationID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	UpdateDistrictDomain(parms: UpdateDistEmailRequest) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/UpdateDistrictEmailDomain";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	GetCalendarInfo(StartDate, EndDate, SchoolID) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/GetCalendarInfo?StartDate=" + StartDate + "&EndDate=" + EndDate + "&SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	CalendarModify(CalendarID, BellScheduleID, SchoolID, DayID, CalendarDate, Comment, IsOpen, UserID, ApplyToAllSchools) {
		var postResult$ = new Subject();
		var url =
			"DistrictAdministration/CalendarModify?CalendarID=" +
			CalendarID +
			"&BellScheduleID=" +
			BellScheduleID +
			"&SchoolID=" +
			SchoolID +
			"&DayID=" +
			DayID +
			"&CalendarDate=" +
			CalendarDate +
			"&Comment=" +
			Comment +
			"&IsOpen=" +
			IsOpen +
			"&UserID=" +
			UserID +
			"&ApplyToAllSchools=" +
			ApplyToAllSchools;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	CalendarModifyWithData(parms: DistCalData) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/CalendarModifyWithData";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	LoadDistrictSecurityPreferenceList() {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/LoadDistrictSecurityPreferenceList?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	UpdateDistrictSecuritySettings(parms: UpdateDistSecurityRequest) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/UpdateDistrictSecuritySettings";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	LoadSchoolInfo(Active: number) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/LoadSchoolInfo?Active=" + Active;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	SchoolSelect(SchoolID) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/SchoolSelect?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	LoadSchoolTypes() {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/SchoolTypeGetList?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	LoadSchoolFacilities(SchoolID) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/GetSchoolFacilities?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	FacilityGetList() {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/FacilityGetList?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	LoadAddSchoolPref() {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/GetAddSchoolPref?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	UpdateSchool(parms: ChangeSchoolRequestModel) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/UpdateSchool";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	LoadDistricts() {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/LoadDistricts?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ToggleSchool(SchoolID, ChangeTo) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/ToggleSchool?SchoolID=" + SchoolID + "&ChangeTo=" + ChangeTo;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	LoadSystemTime() {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/LoadSystemTime?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	SetTimeManually(Date) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/SetTimeManually?Date=" + Date;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ApplicationJobGetList(StartDate, EndDate) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/ApplicationJobGetList?StartDate=" + StartDate + "&EndDate=" + EndDate;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ApplicationGetList() {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/ApplicationGetList?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ApplicationScheduleInsert(parms: ScheduledJobRequestInfo) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/ApplicationScheduleInsert";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ApplicationScheduleUpdate(parms: ScheduledJobRequestInfo) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/ApplicationScheduleUpdate";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ToggleSchedule(ScheduleID, ChangeTo) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/ToggleSchedule?ScheduleID=" + ScheduleID + "&ChangeTo=" + ChangeTo;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ApplicationRunInsert(ApplicationKey, ScheduleID, User_PersonID, CmdLineParms) {
		var postResult$ = new Subject();
		var url =
			"DistrictAdministration/ApplicationRunInsert?ApplicationKey=" +
			ApplicationKey +
			"&ScheduleID=" +
			ScheduleID +
			"&User_PersonID=" +
			User_PersonID +
			"&CmdLineParms=" +
			CmdLineParms;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ApplicationHistoryGetList(BeginDate, EndDate, ScheduleID) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/ApplicationHistoryGetList?BeginDate=" + BeginDate + "&EndDate=" + EndDate + "&ScheduleID=" + ScheduleID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ApplicationRunGetList(StartDate, EndDate, ScheduleID) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/ApplicationRunGetList?StartDate=" + StartDate + "&EndDate=" + EndDate + "&ScheduleID=" + ScheduleID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ApplicationLogGetList(ApplicationRunID) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/ApplicationLogGetList?ApplicationRunID=" + ApplicationRunID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	DistrictZeroOutFinesMeals(parms: ZeroFinesMealRequestModel) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/DistrictZeroOutFinesMeals";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	DistrictZeroOutMerits(parms: ZeroMeritsRequestModel) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/DistrictZeroOutMerits";
		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ZeroPermissionSelect(UserID) {
		var postResult$ = new Subject();
		var url = "SchoolAdmin/ZeroPermissionSelect?UserID=" + UserID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	DistrictZeroOutPBIS(parms: ZeroPBISRequestModel) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/DistrictZeroOutPBIS";
		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	DefaultPageSelectList(UserID) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/DefaultPageSelectList?UserID=" + UserID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	DistrictUpdateDefaultPage(parms: DistrictDefaultPageRequest) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/DistrictUpdateDefaultPage";
		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	DistrictResetDefaultPage() {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/DistrictResetDefaultPage?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	DistrictUpdateNightlyAttendance(parms: DistrictUpdateNightlyAttendanceRequest) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/DistrictUpdateNightlyAttendance?";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	MFAUpdateAllSchools(ChangeTo) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/MFAUpdateAllSchools?ChangeTo=" + ChangeTo;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	AddSchool(parms: AddSchoolRequest) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/AddSchool";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	UserExpirePasswordAll(SchoolID: number) {
		var postResult$ = new Subject();
		var url = "SysAdmin/UserExpirePasswordAll?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	PublicTransitLabelUpdate(parms: StringRequest) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/PublicTransitLabelUpdate";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	HolidaySelectList(SchoolID: number) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/HolidaySelectList?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	CalendarHolidayInsert(parms: CalendarHolidayInsertRequest) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/CalendarHolidayInsert?";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	CalendarHolidayImport(parms: CalendarHolidayImportRequest) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/CalendarHolidayImport?";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	DistrictPortalAppSettingsSelect() {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/DistrictPortalAppSettingsSelect?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	DistrictPortalAppSettingsUpdate(parms: PortalAppSettingsRequest) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/DistrictPortalAppSettingsUpdate?";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
